import { render, staticRenderFns } from "./MenuColumn.vue?vue&type=template&id=18da9870&"
import script from "./MenuColumn.vue?vue&type=script&lang=js&"
export * from "./MenuColumn.vue?vue&type=script&lang=js&"
import style0 from "./MenuColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18da9870')) {
      api.createRecord('18da9870', component.options)
    } else {
      api.reload('18da9870', component.options)
    }
    module.hot.accept("./MenuColumn.vue?vue&type=template&id=18da9870&", function () {
      api.rerender('18da9870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/MenuColumn.vue"
export default component.exports